import styled, { css } from 'styled-components';
import { SEM_TYPOGRAPHY_UI_MD_COPY, SEM_TYPOGRAPHY_UI_MD_HEADLINE, getTypographyStyles, SYS_PAGE_MARGIN_LG, SYS_PAGE_MARGIN_MD, SYS_PAGE_MARGIN_SM, SYS_PAGE_MARGIN_XL, SYS_PAGE_MARGIN_XS, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_400, SYS_SPACE_FIXED_600, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_XL, getMargins } from '@oneaudi/unified-web-common';
export const StyledCarousel = styled.div `
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  margin: ${(props) => getMargins(props.margin)};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    ${(props) => props.variant === 'horizontal' &&
    css `
        flex-direction: row-reverse;
        align-items: center;
      `}
  }
`;
export const StyledSlideContainer = styled.div `
  display: flex;
  overflow: hidden;
  align-self: flex-start;
`;
export const StyledSlide = styled.div `
  flex: 0 0 100%;
  height: 100%;
  line-height: 0;
  // TODO: add motion tokens
  transition: transform 0.5s ease-in-out;
  transform: ${(props) => {
    const offset = (props.current - 1) * 100;
    return `translateX(-${offset}%)`;
}};
`;
export const StyledImage = styled.img `
  aspect-ratio: 4/3;
  width: 100%;
  object-fit: cover;

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    aspect-ratio: 16/9;
  }
`;
export const StyledControlPanel = styled.div `
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN_XS};
  gap: ${SYS_SPACE_FIXED_300};
  justify-content: flex-start;
  width: 100%;

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    padding: ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN_SM};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: ${SYS_SPACE_FIXED_300};
    padding-left: ${SYS_PAGE_MARGIN_MD};
    gap: ${SYS_SPACE_FIXED_300};
    justify-content: center;

    ${(props) => props.pagination &&
    props.variant === 'vertical' &&
    css `
        padding: ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN_MD};
        gap: ${SYS_PAGE_MARGIN_MD};
        flex-direction: row-reverse;
        justify-content: space-between;
      `}
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    padding: ${SYS_SPACE_FIXED_300} ${SYS_SPACE_FIXED_400}
      ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN_LG};
    gap: ${SYS_SPACE_FIXED_350};
    ${(props) => props.variant === 'vertical' &&
    css `
        padding: ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN_LG};
        gap: ${SYS_PAGE_MARGIN_LG};
      `};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    padding: ${SYS_SPACE_FIXED_300} ${SYS_SPACE_FIXED_600}
      ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN_XL};
    gap: ${SYS_SPACE_FIXED_400};
    ${(props) => props.variant === 'vertical' &&
    css `
        padding: ${SYS_SPACE_FIXED_300} ${SYS_PAGE_MARGIN_XL};
        gap: ${SYS_PAGE_MARGIN_XL};
      `};
  }
`;
export const StyledTextSlide = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  // TODO: add motion tokens
  transition: transform 0.5s ease-in-out;
  flex: 0 0 100%;
  transform: ${(props) => {
    const offset = (props.current - 1) * 100;
    return `translateX(-${offset}%)`;
}};
`;
export const StyledHeadline = styled.span `
  ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_HEADLINE)};
  color: ${(props) => props.theme.sem.color.ui.foreground.text.default};
  margin: 0 0 ${SYS_SPACE_FIXED_150} 0;
`;
export const StyledCopy = styled.p `
  ${getTypographyStyles(SEM_TYPOGRAPHY_UI_MD_COPY)};
  color: ${(props) => props.theme.sem.color.ui.foreground.text.default};
  margin: 0;
`;
//# sourceMappingURL=index.styles.js.map